import AccountWidgets from 'features/accounts/components/organisms/AccountWidgets/AccountWidgets';

export default AccountWidgets;
